module.exports = __webpack_public_path__ + "img/coffee-grinded.ad69c112.png";